import { Config } from "../Config.js";
/**
 * Envía un mensaje al padre o a la ventana que abrió esta ventana.
 */
export var postMessageToParent = function (data) {
    if (Config.InIframe || Config.messageParent) {
        window.parent.postMessage(data, "*");
    }
    else if (window.opener) {
        window.opener.postMessage(data, "*");
    }
    else {
        console.warn("No parent or opener found for postMessage.");
    }
};
/**
 * Envía un mensaje de resultado de reconocimiento facial completo.
 */
export var sendLivenessMessage = function (_a) {
    var cmd = _a.cmd, resultAction = _a.resultAction, _b = _a.header, header = _b === void 0 ? "" : _b, _c = _a.code, code = _c === void 0 ? "" : _c, _d = _a.image, image = _d === void 0 ? [] : _d, _e = _a.codeProcess, codeProcess = _e === void 0 ? "" : _e;
    var payload = {
        cmd: cmd,
        resultAction: resultAction,
    };
    if (header) {
        payload.header = header;
    }
    if (code) {
        payload.code = { code: code };
    }
    if (codeProcess) {
        payload.codeProcess = codeProcess;
    }
    if (image.length > 0) {
        payload.image = image;
    }
    postMessageToParent(payload);
};
/**
 * Envía un mensaje simple con resultado y código opcional.
 */
export var sendSimpleLivenessEvent = function (resultAction, code) {
    if (code === void 0) { code = ""; }
    var payload = {
        resultAction: resultAction,
    };
    if (code) {
        payload.code = code;
    }
    postMessageToParent(payload);
};
